
<template>
  <div>
    <DialogNovoCadastro
                        :user="user"
                        :fakeMe="emptyUser"
                        @closed="closedDialog"
                        @updated="novoCadastroCriado"
                        :admin="true"
                        :group_id="group_id"
                        :float-right="true"
                        :dialogStatus="dialogCreate"
                        :hideButton="true"
                        :person-type="personType" />
    <v-autocomplete
                    v-model="value"
                    v-model:search="searchText"
                    :loading="loading"
                    :items="lstObjects"
                    item-title="name"
                    hide-details
                    :custom-filter="customFilter"
                    :label="label"
                    :append-icon="disableCreation && canCreatePerson ? 'mdi-plus' : undefined"
                    @click:append="openDialogNovoCadastro"
                    clearable
                    :multiple="multiple"
                    return-object
                    density="compact"
                    :rules="rules"
                    @update:modelValue="objectSelected">
      <template v-slot:no-data>
        <div class="px-4">Digite sua busca</div>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import DialogNovoCadastro from "../components/DialogNovoCadastro.vue";
import api from '@/services'
export default {
  components: { DialogNovoCadastro },
  props: {
    user: Object,
    label: String,
    customTypes: Array,
    group_id: Number,
    multiple: Boolean,
    modelValue: Object | Number,
    personType: Number,
    rules: Array,
    disableCreation: Boolean
  },
  emits: ["update:modelValue", "selected", "closed"],
  data() {
    return {
      requestingApi: false,
      searchText: null,
      preciousSearch: null,
      loading: false,
      lstObjects: [],
      timeoutSearchDelay: null,
      dialogCreate: false,
      legal_person: {},
      emptyUser: {}
    };
  },
  created() {
    const vm = this;
    const isNumber = typeof vm.modelValue == 'number';
    const isObject = typeof vm.modelValue == 'object';
    const hasId = vm.modelValue?.id != null;
    const isPresent = isObject && hasId && !!vm.lstCustomObjects.find(lp => lp.id == vm.modelValue);

    if (isNumber || (hasId && !isPresent)) {
      vm.get(isNumber ? vm.modelValue : vm.modelValue.id).then((person) => {
        vm.value = vm.multiple ? [person] : person;
        vm.lstObjects.push(person);
      });
    }
  },
  mounted() { },
  activated() { },
  methods: {
    openDialogNovoCadastro() {
      var vm = this;

      vm.dialogCreate = true
    },
    closedDialog() {
      var vm = this;
      vm.emptyUser = {};
      vm.dialogCreate = false;
    },
    objectSelected(selected) {
      const vm = this;

      vm.$emit("selected", selected);
    },
    novoCadastroCriado(legalPerson) {
      var vm = this;

      if (legalPerson) {
        let customName = `${legalPerson?.name} - ${legalPerson?.ssn}`;
        vm.legal_person = {
          customName,
          ...legalPerson
        };
        vm.emptyUser = {
          legal_person: legalPerson
        };
      } else {
        vm.legal_person = null;
      }
    },
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 1500);
        vm.loading = true;
      }
    },
    customFilter(item, queryText, itemText) {
      return true;
    },
    submitSearch(page) {
      var vm = this;

      if (!vm.requestingApi) {
        let _searchText = vm.searchText;
        let _prev = (vm.preciousSearch || "").toUpperCase();
        let _act = (_searchText || "").toUpperCase();
        if (_act == "" || (_act == " " && _prev == _act)) {
          vm.loading = false;
          return;
        }
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.legalPerson
            .search({ searchText: _searchText, types: vm.customTypes, withUser: true })
            .then((result) => {
              vm.preciousSearch = _searchText;
              vm.lstObjects = result;
              resolve(vm.lstObjects);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
                reject(err.message);
              }
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
            });
        });
      }
    },
    get(id) {
      var vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.loading = true;
        return new Promise((resolve, reject) => {
          api.legalPerson
            .get(id)
            .then((result) => {
              if (result) {
                const person = { customName: `${result.name} ${result.ssn ? "-" + result.ssn : ""}`, ...result };
                vm.lstObjects.push(person);
                resolve(person);
              }
              resolve(null);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
                reject(err.message);
              }
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
            });
        });
      }
    }
  },
  computed: {
    hasAdminAccess() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },
    canCreatePerson() {
      return this.hasAdminAccess || this.user.access_level == this.$USER_ACCESS_LEVELS_DIC.CHIEF.value;
    },
    lstCustomObjects() {
      var vm = this;
      let _customLst = [];
      vm.lstObjects.forEach((obj) => {
        let customName = `${obj.name} ${obj.ssn ? "-" + obj.ssn : ""}`;
        _customLst.push({
          customName,
          ...obj,
        });
      });
      return _customLst;
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.$emit("closed");
      }
    },
    legal_person(newVal) {
      this.$emit("selected", newVal);
      if (newVal) {
        this.dialogCreate = false;
      }
    },
    searchText(newVal, oldVal) {
      if (
        newVal && oldVal &&
        newVal != " " &&
        newVal.toUpperCase() != oldVal.toUpperCase()
      ) {
        this.waitAndSearch();
      }
    },
  },
};
</script>
